window.$ = window.jQuery = require('jquery');

require('./bootstrap');
require('./landings/formations-photo-passion');